import BhilosaDashboard from "./BhilosaDashboard";

export default BhilosaDashboard;